import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('admToken'));
  const [user, setUser] = useState(localStorage.getItem('user'));

  const login = async (username, password) => {
    try {
      const response = await axios.post(`${API_URL}/admin/login`, { username, password });
      
      const { token, user: userData } = response.data;
      
      localStorage.setItem('admToken', token);
      localStorage.setItem('user', userData.username);

      setIsAuthenticated(true);
      setUser(userData.username);
      
      return { success: true };
    } catch (error) {
      console.error('Error logging in:', error);
      return { success: false, message: error.response?.data?.message || 'Invalid credentials' };
    }
  };

  const logout = () => {
    localStorage.removeItem('admToken');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
    window.location.href = '/'; 
  };

  useEffect(() => {
    const handleStorageChange = () => {
      setIsAuthenticated(!!localStorage.getItem('admToken'));
      setUser(localStorage.getItem('user'));
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);


  return { isAuthenticated, user, login, logout };
};

export default useAuth;